module.exports = __webpack_public_path__ + "img/tintuc7.b119d16e.png";